module.exports = __webpack_public_path__ + "static/img/thumb-04.f459c1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/global_assets/images/shipping-label/system/thumb/thumb-04.png
// module id = 1U27
// module chunks = 31